























































































































interface DomDate {
    title: string
    value: string
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

import ScrollToBottomVue from "@/components/ScrollToBottom.vue";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "sctollTo-bottom": ScrollToBottomVue
    }
})
export default class TaxEntry extends Vue {
    companyList: AccountBookList.AccountBook[] = []
    searchModel: string = "" //搜索
    empty: boolean = true; //是否有搜索按钮
    companyName: string = ""
    index: number = 0 //选中公司的index
    taxStatus: number = 0
    dateTime: Date = new Date(); // 显示时间
    period: string = ""
    recordValue: string = "";
    recodeSearchKey: boolean = false;
    domListData: DomDate[] = [{ title: "收入（元）", value: "income" }, { title: "增值税", value: "vaddedTax" }, { title: "消费税", value: "saleTax" }, { title: "印花税", value: "stampTax" }, { title: "城建税", value: "conTax" }, { title: "教育费附加", value: "eduSurtax" }, { title: "地方教育费附加", value: "locEduTax" }, { title: "个人所得税", value: "psIncTax" }, { title: "文化建设费", value: "culFee" }, { title: "所得税", value: "incomeTax" }];
    emptyInput() {
        this.searchModel = "";
        this.querySearch("");
    }
    // 搜索功能
    querySearch(queryString: string) {
        queryString = queryString.trim();
        this.page = 0;
        if (queryString != "") {
            this.empty = false;
            this.query = queryString;
            this.companyList = [];
            Vue.axios
                .post(
                    `taxs/getaccountbooklist?page=${this.page}&size=${this.size}`, {
                    accounterNo: this.$store.state.account.no,
                    query: this.query
                })
                .then(res => {
                    this.totalPages = res.data.totalPages;
                    this.companyList = res.data.content
                    if (this.companyList.length > 0) {
                        this.changeCompany(this.companyList[0], 0);
                    }
                    this.recodeSearchKey = true;
                });
        } else {
            this.empty = true;
            if (this.recodeSearchKey) {
                this.recodeSearchKey = false;
                this.companyList = [];
                this.query = "";
                this.fetchData();
            }
        }
    }
    mounted() {
        this.dateTime = new Date(this.$store.state.collectPeriod.substr(0, 4) + "-" + this.$store.state.collectPeriod.substr(4));
        this.period = this.$utils.simpleDateFormat(this.dateTime, "m");
        this.fetchData()
    }
    // 获取时间范围
    get disabledDate() {
        return {
            disabledDate: (time: Date) => {
                let endTime = new Date(this.$store.state.collectPeriod.substr(0, 4) + "-" + this.$store.state.collectPeriod.substr(4));
                let end: Date = endTime;
                return time.getTime() > end.getTime();
            }
        }
    };
    // 获取编辑区数据
    page: number = 0;
    size: number = 20;
    totalPages: number = 1;
    query: string = ""
    init: boolean = true;
    fetchData() {
        Vue.axios.post(`taxs/getaccountbooklist?page=${this.page}&size=${this.size}`, {
            accounterNo: this.$store.state.account.no,
            query: this.query
        })
            .then(res => {
                this.totalPages = res.data.totalPages;
                if (res.data.content.length > 0) {
                    for (var i = 0; i < res.data.content.length; i++) { this.companyList.push(res.data.content[i]) }
                    if (this.init) {
                        this.changeCompany(this.companyList[this.index], this.index);
                        this.init = false;                    }
                }
            });
    }
    // 选择时间
    changeDate(val: Date) {
        this.period = this.$utils.simpleDateFormat(val, "m");
        this.changeCompany(this.companyList[this.index], this.index);
    }
    // 点击列表
    checkedOne: boolean = false
    checkedTwo: boolean = false
    checkedThree: boolean = false
    ediData: any = {}
    ediCopyData: any = {}
    changeCompany(item: AccountBookList.AccountBook, index: number) {
        for (var i = 0; i < this.companyList.length; i++) { this.companyList[i].clsStatus = false; }
        item.clsStatus = true;
        this.index = index;
        this.companyName = item.bookName;
        Vue.axios
            .get(`taxs/` + item.id + `/find?period=${this.period}`)
            .then(res => {
                this.ediData = res.data;
                this.taxStatus = res.data.taxStatus;
                if (this.ediData) {
                    Object.keys(this.ediData).forEach(attr => {
                        // @ts-ignore
                        this.ediCopyData[attr] = this.ediData[attr]
                    });
                }
                if (res.data.copyTaxes != null) {
                    this.checkedOne = res.data.copyTaxes == 0 ? false : true;
                    this.checkedTwo = res.data.report == 0 ? false : true;
                    this.checkedThree = res.data.finished == 0 ? false : true;
                } else {
                    this.checkedOne = false;
                    this.checkedTwo = false;
                    this.checkedThree = false;
                }
            });
    }
    // 点击上一个图标
    fnPre() {
        var index = this.index;
        if (this.companyList.length < 2 || index == 0) { this.$message.warning("亲，已经是第一个了") } else { this.changeCompany(this.companyList[index - 1], index - 1); }
    }
    // 点击下一个图标
    fnNext() {
        var index = this.index;
        if (this.companyList.length < 2 || this.companyList.length == index + 1) {
            this.$message.warning("亲，已经是最后一个了")
        } else { this.changeCompany(this.companyList[index + 1], index + 1); }
    }
    // 编辑区光标进入
    selectAll(el: any) {
        el.currentTarget.select();
        this.recordValue = el.currentTarget.value;
    }
    // 编辑区光标离开
    blur(el: any, key: string) {
        if (el.currentTarget.value.indexOf(",") == -1) {
            if (el.currentTarget.value === "") {
                el.currentTarget.value = this.recordValue            }
            else {
                if (el.currentTarget.value === "0" || el.currentTarget.value === "" || el.currentTarget.value === "0.00") {
                    if (this.ediData) this.ediData[key] = <any>"0.00";
                } else {
                    // let value = this.$utils.currency(el.currentTarget.value)
                    if (this.ediData) this.ediData[key] = <any>el.currentTarget.value;
                }
            }
        }
    }
    // 编辑区keydown
    arrowPress(e: any, index: any, numInput: any) {
        if (numInput) {
            let keycodes = [8, 9, 12, 13, 32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 109, 110, 187, 189, 190]
            if (keycodes.indexOf(e.keyCode) == -1) {
                e.preventDefault();
                return
            }
        }
        let inputs: any = document.querySelectorAll("#accounts .content")
        if (e.keyCode == 39 || e.keyCode == 13) {
            e.preventDefault();
            if (index < inputs.length - 1) {
                inputs[index + 1].focus()
            }
        } else if (e.keyCode == 37) {
            e.preventDefault();
            if (index > 0) {
                inputs[index - 1].focus()
            }
        }
    }
    // 取消
    cancle() {
        if (this.ediCopyData) {
            Object.keys(this.ediCopyData).forEach(attr => {
                // @ts-ignore
                this.ediData[attr] = this.ediCopyData[attr]
            });
        }
        if (this.ediData) {
            if (this.ediData.copyTaxes === null) {
                this.checkedOne = false
                this.checkedTwo = false
                this.checkedThree = false
            } else {
                this.checkedOne = this.ediData.copyTaxes == 0 ? false : true;
                this.checkedTwo = this.ediData.report == 0 ? false : true;
                this.checkedThree = this.ediData.finished == 0 ? false : true;
            }
        }
    }
    // 点击保存
    save() {
        this.ediData.copyTaxes = this.checkedOne == true ? 1 : 0;
        this.ediData.report = this.checkedTwo == true ? 1 : 0;
        this.ediData.finished = this.checkedThree == true ? 1 : 0;
        Vue.axios.post(`taxs/add`, this.ediData)
            .then(res => {
                if (res.status == 200) {
                    this.taxStatus = res.data.taxStatus;
                    this.ediData.id = res.data.id;
                    Object.keys(this.ediData).forEach(attr => {
                        // @ts-ignore
                        this.ediCopyData[attr] = this.ediData[attr]
                    });
                    this.$message.success("保存成功")
                }
            });
    }


}
